<script lang="ts">
    export let selectedId: string = 'a';
    export let items: { id: string; label: string }[] = [
        { id: 'a', label: 'aaa' },
        { id: 'b', label: 'bbb' },
    ];
    export let onChange: (id: string) => void = () => {};
</script>

<div class="tab-container">
    {#each items as item}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="tab-item"
            class:active={item.id === selectedId}
            on:click={() => {
                selectedId = item.id;
                onChange(item.id);
            }}
        >
            {item.label}
        </div>
    {/each}
</div>

<style>
    .tab-container {
        display: flex;
        column-gap: 2px;
        border-radius: 8px;
        background-color: #f0f0f0;
        padding: 6px 6px;
    }
    .tab-item {
        border-radius: 4px;
        cursor: pointer;
        flex: 1 1 auto;
        color: #000a;
        text-align: center;
        padding: 6px 6px;
        font-weight: 500;
        font-size: 14px;
    }
    .tab-item.active {
        /*background-color: #ccc;*/
        background-color: #1c5dc7;
        color: #fff;
    }
</style>
